import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "gear-image-container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gear-button-container", { 'equipped-slot': _ctx.isEquipped }]),
    key: _ctx.item.name,
    title: `Equip ${_ctx.item.name}`,
    style: _normalizeStyle(`justify-content: ${_ctx.itemIndex % 2 ? 'flex-end' : 'flex-start'}`),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.equipItem(_ctx.gearSlot, _ctx.item.image)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "gear-image",
        src: _ctx.getGearImage(_ctx.gearSlot, _ctx.item.image),
        alt: "gear image"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", {
      class: "gear-text-container",
      style: _normalizeStyle(_ctx.itemIndex % 2 ? 'left: 2px;' : 'right: 2px;')
    }, _toDisplayString(_ctx.item.name), 5),
    (_ctx.item.statsAllowed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "craft-icon-container",
          style: _normalizeStyle(`${_ctx.itemIndex % 2 === 0 ? 'left: -4px;' : 'right: -4px;'}`)
        }, [
          _createVNode(_component_GenericButton, {
            svg: "craft",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.craftItem(_ctx.item)), ["stop"])),
            title: `Create statted ${_ctx.item.name}`
          }, null, 8, ["title"])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.item.note)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "info-icon-container",
          style: _normalizeStyle(`${_ctx.itemIndex % 2 ===0 ? 'left: -2px;' : 'right: -2px;'}`)
        }, [
          _createVNode(_component_GenericButton, {
            class: "cursor-help",
            svg: "question",
            "svg-width": "14px",
            "svg-height": "14px",
            "svg-color": "var(--text-yellow)",
            onClick: _withModifiers(() => {}, ["stop"]),
            title: _ctx.item.note
          }, null, 8, ["title"])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.item.warning)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "warn-icon-container",
          style: _normalizeStyle(`${_ctx.itemIndex % 2 ? 'right: -3px;' : 'left: -3px;'}`)
        }, [
          _createVNode(_component_GenericButton, {
            class: "cursor-help",
            svg: "exclamation",
            "svg-width": "16px",
            "svg-height": "16px",
            "svg-color": "var(--text-red)",
            onClick: _withModifiers(() => {}, ["stop"]),
            title: _ctx.item.warning
          }, null, 8, ["title"])
        ], 4))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}